<template>
    <div class="flex items-center mt-4">
        <div class="bg-growth rounded-full text-white p-2 fixed z-50 top-5 px-6 left-1/2" v-if="saved">{{ $t('saved') }}</div>
        {{ $t('base_salary') }} {{ $t('pricing_section.per_month') }}: 
        <MazInputPrice 
            class="w-28 mx-2 text-center" 
            :label="$t('base_salary')"
            size="sm"
            v-model="baseSalary" 
            currency="USD"
            locale="en-US"
        />
        {{ $t('for') }}
        <MazInput 
            class="w-20 mx-2 text-center" 
            :label="$t('hours')"
            type="number"
            size="sm"
            v-model="baseSalaryH" 
        /> {{ $t('hours') }} {{ $t('pricing_section.per_month') }}
        <MazBtn size="xs" class="ml-5" @click="saveCompanySalaryMonthly()">Save <font-awesome-icon icon="fas fa-floppy-disk" /></MazBtn>
    </div>
</template>

<script>
    import { api_post_call } from '@/api/api.js';
    export default {
        props: ['salary','sHours'],
        data() {
            return {
                baseSalaryH:0,
                baseSalary:0,
                saved:false
            }
        },
        methods: {
            async saveCompanySalaryMonthly() {
                if (this.baseSalary>0) {
                    let response = await api_post_call(`settingspost/`, {
                        action: 'salaryMonthBase',
                        baseSalary: this.baseSalary,
                        baseSalaryHours: this.baseSalaryH,
                        userToken: this.$cookies.get('userToken'),
                        companyID: this.$cookies.get('c_id')
                    });
                    if (response) {
                        this.saved = true;
                        setTimeout(() => (this.saved = false),500);
                    }
                }
            }
        },
        created() {
            this.baseSalaryH = this.sHours;
            this.baseSalary = this.salary;
        }
    }
</script>